<div class="modal-body">
  @if ((messageItemsAsObservable | async).length > 0) {
    <div class="mb-4">
      <rask-message-panel
        [numberOfItemsToDisplay]="2"
        [maxNumOfRows]="2"
        [items]="messageItemsAsObservable">
      </rask-message-panel>
    </div>
  }
  <div class="row"><rask-input class="col-12" label="Destineringsursprung" [value]="destineringsursprung" [readonly]="true"></rask-input></div>

  <div class="row">@if (tableColumns) {
    <rask-table [editable]="false" [data]="allaKontraktsrader" [columns]="tableColumns" [noScroll]="true"></rask-table>
  }</div>

  <form [formGroup]="form">
    <rask-multi-selector
      aid="inputSortiment"
      class="col-12"
      label="Extra sortiment"
      bindLabel="namn"
      formControlName="extraSortiment"
      typeToSearchText="Ange minst tre tecken"
      loadingText="Laddar..."
      notFoundText="Ingen träff"
      [minTermLength]="3"
      [disabled]="!data.canEdit"
      [typeaheadFn]="searchForSortiment"
      [selected]="form.value.sortiment"
      (change)="extraSortimentChanged()">
    </rask-multi-selector>
  </form>
</div>

@if (isLoading) {
  <div class="loading">
  </div>
}
@if (isLoading) {
  <rask-busy-spinner size="5" class="spinner"></rask-busy-spinner>
}

<div class="modal-footer">
  <rask-button color="primary" (click)="spara()" [disabled]="!canSave()">Spara</rask-button>
  <rask-button color="secondary" (click)="close()">Stäng</rask-button>
</div>
